import jsonView from './json-view/index.vue'
export default  jsonView



// WEBPACK FOOTER //
// ./src/index.js